module.exports = __webpack_public_path__ + "img/check.59d96fce.svg";